var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainBox",class:[_vm.$style.container, _vm.$style.paddingbottombig]},[_c('div',[_c('NavBar'),_vm._t("default")],2),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }